
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const ZINKPage = () => {
  const media = 
  [
    '/images/assembly.webp', 
    '/images/emotion.webp', 
    "/images/moth.webp"
  ];

  return (
    <div className="zink-page">
      <ProjectTemplate
        title="ZINK"
        year="2020-current"
        sections={[
          {
            type: "description",
            text: 'ZINK is an ongoing project with which I explore electronic using funky synthesis methods and with heavy inspirations from modern bass-music. Sometimes it involves recycling creax music. "E-motion" and "Assembly" album covers are designed by Aliz Soós.',
          },
 
          {
            type: "image",
            links: [
              {
                src: media[2],
                href: "https://open.spotify.com/album/4yLO9mfovpgEGgqbp6uaGD?si=skKI3XvVQGGWl5aIA2kukg",
                text: 'M O T H',
                year: '2 0 2 5'
              },
              {
                src: media[0],
                href: 'https://open.spotify.com/album/44xmjHzeZ9F2RxggDzxx9L?si=EQ9cBXaFQEGnF3Myx9LunA',
                text: 'a s s e m b l y',
                year: '2 0 2 4'           
              },
              {
                src: media[1],
                href: 'https://open.spotify.com/album/6N5sKbks1FHhJLib1nCaLk?si=Y-xq8vQFSCacf9wrIrSw0w',
                text: 'e - m o t i o n',
                year: '2 0 2 3'
              }
            ],
            isLink: true,
          },
          // {
          //   type: "description",
          //   text: 'I also use ZINK as the main project to produce music at Showsync'
          // },
          // {
          //   type: 'video',
          //   links: ['https://www.youtube.com/embed/hkhn08ebyRw?si=AssNnX9agddG5U2W']
          // }
        ]}
      />
    </div>
  );
};

export default ZINKPage;
